module.exports = __webpack_public_path__ + "static/media/Contacts01.7b694159.png";